import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class DiscoveryMode extends Cloneable {

    static DEFAULT = new DiscoveryMode(0, "DEFAULT");
    static EXTEND_DEFAULT = new DiscoveryMode(1, "EXTEND_DEFAULT");
    static EXTEND_CUSTOM = new DiscoveryMode(2, "EXTEND_CUSTOM");

    static _values = [
        this.DEFAULT,
        this.EXTEND_DEFAULT,
        this.EXTEND_CUSTOM
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, DiscoveryMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof DiscoveryMode) {
            return DiscoveryMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DISABLED") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof DiscoveryMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new DiscoveryMode());
        } else if (target instanceof DiscoveryMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(DiscoveryMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});